import {Map} from 'immutable';
import {
  CLOSE_ADD_POST_DIALOG,
  OPEN_ADD_POST_DIALOG,
} from '../../actions';

const initialState = new Map({
  addPostDialogIsOpen: false,
});

export default function (state = initialState, action) {
  switch (action.type) {

    case OPEN_ADD_POST_DIALOG:
      return state.set('addPostDialogIsOpen', true);

    case CLOSE_ADD_POST_DIALOG:
      return state.set('addPostDialogIsOpen', false);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/features/newCommunityPost/reducers/pages/addPostDialog.js